function isDataCalendarioValida(dia, mes, ano) {
  const dataObj = new Date(ano, mes - 1, dia);
  return (
    dataObj.getFullYear() === ano &&
    dataObj.getMonth() === mes - 1 &&
    dataObj.getDate() === dia
  );
}

/**
 * Valida se o valor é uma data válida no formato dd/MM/yyyy ou yyyy-MM-dd (ou vazio).
 * @param {*} data - Valor a validar (string, null, undefined).
 * @returns {boolean} true se for vazio ou data válida; false caso contrário.
 */
const validarData = (data) => {
  if (data === "" || data === undefined || data === null) return true;

  const str = String(data).trim();
  const matchBr = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (matchBr) {
    return isDataCalendarioValida(
      parseInt(matchBr[1], 10),
      parseInt(matchBr[2], 10),
      parseInt(matchBr[3], 10)
    );
  }

  const matchIso = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (matchIso) {
    return isDataCalendarioValida(
      parseInt(matchIso[3], 10),
      parseInt(matchIso[2], 10),
      parseInt(matchIso[1], 10)
    );
  }

  return false;
};

export default validarData;
